import React from 'react';
import { signOut } from 'firebase/auth';
import { FIREBASE_AUTH } from '../../Firebase';
import { useNavigate } from 'react-router-dom';

interface NoAccessProps {}

const NoAccess: React.FC<NoAccessProps> = () => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(FIREBASE_AUTH);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
      // If sign out fails, still redirect to login
      navigate('/login');
    }
  };

  return (
    <div style={{
      position: 'relative',
      minHeight: '100vh'
    }}>


      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        padding: '2rem'
      }}>
        <div style={{
          position: 'relative',
          maxWidth: '500px',
          padding: '2rem',
          border: '1px solid #ddd',
          borderRadius: '8px',
          backgroundColor: '#f9f9f9'
        }}>
          {/* Return to Unison button in top left of the white box */}
          <button
            onClick={() => window.location.href = 'https://unison.org.uk'}
            style={{
              position: 'absolute',
              top: '0.5rem',
              left: '0.5rem',
              padding: '0.4rem 0.8rem',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.8rem',
              zIndex: 10
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#545b62';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#6c757d';
            }}
          >
            Return to UNISON
          </button>
          <div style={{
            fontSize: '4rem',
            color: '#d32f2f',
            marginBottom: '1rem'
          }}>
            🚫
          </div>
          
          <h1 style={{
            color: '#d32f2f',
            fontSize: '2rem',
            marginBottom: '1rem'
          }}>
            Access Denied
          </h1>
          
          <p style={{
            color: '#666',
            fontSize: '1.1rem',
            marginBottom: '1.5rem',
            lineHeight: '1.5'
          }}>
            You don't have access to view this page.
          </p>
          
          <p style={{
            color: '#888',
            fontSize: '0.9rem',
            marginBottom: '2rem'
          }}>
            If you believe this is an error, please contact your administrator.
          </p>
          
          <button
            onClick={handleSignOut}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '1rem',
              marginRight: '1rem'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#0056b3';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#007bff';
            }}
          >
            Sign Out
          </button>
          
          <button
            onClick={() => navigate('/deleteaccount')}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#d32f2f',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#b71c1c';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#d32f2f';
            }}
          >
            Delete Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoAccess;